<template>
  <div style="width:100%;">
    <v-container>
      <v-form @submit="addTask">
        <v-card style="width:100%;margin-left:auto;margin-right:auto;" outlined>
          <v-card-title>
            <h3>{{ $t("addtask.header") }}</h3>
          </v-card-title>
          <v-card-text style="padding:15px;">
            <v-text-field type="text" :label="$t('addtask.name')" v-model="name"></v-text-field>
            <v-textarea v-model="description" :label="$t('addtask.description')"></v-textarea>
            <v-select :label="$t('addtask.interval')" v-model="interval" :items="intervals"></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text type="submit">{{ $t("addtask.add") }}</v-btn>
            <v-btn color="default" text type="button" @click="openTasks">{{ $t("addtask.cancel") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { Notifications } from "../notification";
import { storage } from "../schmucklicloud";

import intervals from "../assets/data/intervals";

export default {
  data() {
    return {
      name: "",
      description: "",
      interval: "",
      intervals: intervals.map(entry => { entry.text = this.$t(entry.text); return entry;})
    };
  },
  methods: {
    async addTask(e) {
      e.preventDefault();
      var response = await storage.insert("tasks", {
        name: this.name,
        description: this.description,
        interval: this.interval
      });
      if (response.status_code === 200) {
        this.$router.replace("/");
        Notifications.show("Task has been saved.");
      } else {
        Notifications.show(response.message);
      }
    },
    openTasks() {
      this.$router.replace("/");
    }
  }
};
</script>

<style>
</style>